import React from 'react';
import Form from './index';

export default ({
  fields,
  validations,
  value,
  onChange,
  title = '',
  subTitle = '',
  changeFields = [],
  fieldsValues = {},
  error = {},
  validateOnBlur,
}) => (
  <>
    <div className="form-field">
      {!!title && <p className="form-field-title color-base">{title}</p>}
      {!!subTitle && <p className="form-field-sub-title">{subTitle}</p>}
      <Form
        fields={fields}
        fieldsValues={fieldsValues}
        validations={validations}
        isSubmit={false}
        isCancel={false}
        onChange={(e) => onChange({ ...e })}
        onProps={value}
        validationErrors={!validateOnBlur ? error : Object.keys(error).length ? error : null}
        changeFields={changeFields}
        validateOnBlur={validateOnBlur}
      />
    </div>
  </>
);
